import React, { useEffect, useState } from 'react';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import { useToast } from 'context/providers/ToastProvider';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { Card, Col, Row } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';

const SeccionLogs = (

    {
        idLicencia,
    }

) => {

    const { token } = useToken();
    const { showErrorToast } = useToast();

    const [logServicios, setLogServicios] = useState([]);

    /**
     * Obtiene los datos Seccion Logs
     */
    const ObtieneSeccionLogs = async () => {
        try {
            // setCargando(true);
            const response = await fetch(`/api/licencia/ObtieneSeccionLogs/?id=${idLicencia}`, {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    window.location.href = "";
                    return;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                console.log("Seccion Logs", ObjDetalles)

                setLogServicios(ObjDetalles.table2);
               



            }





        } catch (error) {
            showErrorToast(error.message);
            console.error('Error al obtener datos de la licencia:', error);
        } finally {
            //setCargando(false);
        }
    };



    useEffect(() => {
        ObtieneSeccionLogs();
    }, [idLicencia]);




    /**
   * Columnas para los logs
   */
    const columnsLogs = [
        {
            accessor: 'dCreadtedDate',
            Header: 'Fecha movimiento',
            maxWidth: 100,
            minWidth: 100,
            width: 100,
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { dCreatedDate } = rowData.row.original;
                return (<span>{dCreatedDate}</span>)
            }
        },
        {
            accessor: 'vCreatedUser',
            Header: 'Usuario',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vCreatedUser, bIsPeriodoPrueba } = rowData.row.original;
                return bIsPeriodoPrueba ? (<span className="text-danger text-truncate" style={{ maxWidth: '350px' }}>{vCreatedUser}</span>) : (<span className="text-truncate" style={{ maxWidth: '350px' }}> {vCreatedUser}</span>)
            }
        },
        {
            accessor: 'vNombreSucursal',
            Header: 'Nombre Sucursal',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vNombreSucursal, bIsPeriodoPrueba } = rowData.row.original;
                return bIsPeriodoPrueba ? (<span className="text-danger text-truncate" style={{ maxWidth: '350px' }}>{vNombreSucursal}</span>) : (<span className="text-truncate" style={{ maxWidth: '350px' }}> {vNombreSucursal}</span>)
            }
        },
        {
            accessor: 'vVersion',
            Header: 'Version',
            cellProps: { className: 'ps-1 fs--1' },
            Cell: rowData => {
                const { vVersion } = rowData.row.original;
                return <code>
                    {vVersion}
                </code>
            }
        },
        {
            accessor: 'vMovimiento',
            Header: 'Movimiento',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vMovimiento, bIsPeriodoPrueba } = rowData.row.original;
                return bIsPeriodoPrueba ? (<span className="text-danger d-inline-block text-truncate" >{vMovimiento}</span>) : (<span className="d-inline-block text-truncate" >{vMovimiento}</span>)
            }

        }
    ];

    return (
        <Row className="g-3 mb-3">
            <Col lg={12}>
                <Card className="mb-3">
                    <Card.Header>
                        <h5 className="mb-0">&Uacute;ltimos Logs del licenciatario</h5>
                    </Card.Header>
                    <Card.Body className="border-top p-0">
                        <AdvanceTableWrapper
                            columns={columnsLogs}
                            data={logServicios}

                            sortable
                            pagination
                            perPage={15}
                        >
                            <Card className="px-3">
                                <Card.Header>

                                </Card.Header>
                                <Card.Body className="p-0">
                                    <AdvanceTable
                                        table
                                        headerClassName="bg-200 text-900 text-nowrap align-middle"
                                        rowClassName="align-middle white-space-nowrap"
                                        tableProps={{
                                            size: 'sm',
                                            striped: true,
                                            hover: true,
                                            className: 'fs--2 mb-0 overflow-hidden'
                                        }}
                                    />

                                </Card.Body>
                                <Card.Footer>
                                    <AdvanceTableFooter
                                        rowCount={logServicios.length}
                                        table
                                        rowInfo
                                        navButtons
                                        rowsPerPageSelection
                                    />
                                </Card.Footer>
                            </Card>
                        </AdvanceTableWrapper>
                    </Card.Body>
                    <Card.Footer className="bg-light p-0">

                    </Card.Footer>
                </Card>
            </Col>
        </Row>
    )
}

SeccionLogs.propTypes = {

    idLicencia: PropTypes.string

};

export default SeccionLogs;